module.exports = __webpack_public_path__ + "img/12csm_Ersa-Wave-8948-900x600_56c1d52b04.af9a5e24.jpg";